var Backbone = require('backbone'),
    ShapeUtils = require('../../../shapeUtils');


module.exports = Backbone.Model.extend({

    defaults: {
        points: [],
        color: '#000000',
        opacity: 0.35,

        /*
        *  Note: these are the 'base' values: the ones applied when rendering are multiplied by width.
        *  This is done by drawing programs ... it comes into play by making the dash look better on lines with different widths,
        *  eg: try with a higher width and without the calculation.
        *  Default is just 1 item but leave the option open for more if later desired.
        * */
        dashArray: [ +( ShapeUtils.ptToTenthsMM( 1 ).toFixed(3)  ) ],

        //  width: configurable but there are problems:
            // if wide, top doesn't align with default position ( points connected from center )
        width: +( ShapeUtils.ptToTenthsMM( 1 ).toFixed(3) ) // ( now the same as code box width by default ) -- TODO: share it

    },
    /*
    *  If value read from db is null, don't allow it to be set to the default defined here.
    *  This is done in  constructor code: if (defaults = _.result(this, 'defaults')) { attrs = _.defaults({}, attrs, defaults); },
    *  where _.defaults applies the models defaults if corresponding attributes are undefined ...
    *  but here, dashArray is set to null if none is to be applied and we want to leave it's default value defined in the model defaults.
    * */
    constructor: function(attrs, options) {

        Backbone.Model.prototype.constructor.apply( this, arguments );

        if (!attrs)
            return;

        if ( !attrs.dashArray ) {

            this.set({
                dashArray: null
            }, options);
        }
    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/models/coordinate/redaction/floating/connection.js
 ** module id = 250
 ** module chunks = 0
 **/